import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";

import { useDispatch } from "react-redux";
import InsertMessageSet from "./InsertMessageSet";

import {
  createMessageGroup,
  updateMessageGroup,
} from "../../redux/actions/messageGroupSettings";

const initialValues = {
  title: "",
  blocks: [],
};

const validateForm = (values) => {
  if (!values.title.trim()) {
    return {
      pass: false,
      errorMsg: "Please enter a title",
    };
  } else if (!values.blocks || values.blocks.length < 1) {
    return {
      pass: false,
      errorMsg: "Please add atleast one block",
    };
  } else {
    return {
      pass: true,
    };
  }
};

const MessageGroupForm = ({ selectedMessageGroup, setOpenForm }) => {
  const [messageGroupData, setMessageGroupData] = useState(initialValues);
  // console.log("messageGroupsSettings", messageGroupsSettings);
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("selectedMessageGroup", selectedMessageGroup)
    if (selectedMessageGroup?._id) {
      setMessageGroupData(selectedMessageGroup);
    } else {
      setMessageGroupData({ title: "", blocks: [] });
    }
  }, [selectedMessageGroup]);

  // useEffect(() => {
  //   if (!selectedMessageGroup?._id) {
  //     setMessageGroupData({ title: "", blocks: [] });
  //   }
  // }, [openForm]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationRes = validateForm(messageGroupData);
    if (validationRes.pass) {
      // console.log("messageGroupData", messageGroupData);
      if (selectedMessageGroup?._id) {
        dispatch(
          updateMessageGroup(messageGroupData, selectedMessageGroup?._id)
        );
      } else {
        dispatch(createMessageGroup(messageGroupData));
      }
      setOpenForm(false);
      return true;
    } else {
      toast.error(validationRes.errorMsg);
      return false;
    }
  };

  const handleRemoveMessageBlock = (index) => {
    const result = messageGroupData?.blocks?.filter((_, i) => i !== index);
    setMessageGroupData({
      ...messageGroupData,
      blocks: result,
    });
  };

  return (
    <div className="">
      <div className="modalDivWraper customizedModal activated">
        <div className="modalHeaderWraper">
          <h4 className="modalHeading">Create Message Group</h4>
        </div>
        <div className="innerModalWraper  messageFormWraper">
          <div className="fieldWrapers modalFields messageGroupModalWrapers">
            {/* <h4 className="modalHeading">Create Message Group</h4> */}
            <div className="input-group">
              <p className="message-segment-label">Enter Title</p>
              <div className="">
                <input
                  type="text"
                  className="message-segment-input"
                  placeholder="Enter your message group title"
                  style={{ marginBottom: "0px" }}
                  onChange={(e) =>
                    setMessageGroupData({
                      ...messageGroupData,
                      title: e.target.value,
                    })
                  }
                  value={messageGroupData?.title}
                />
              </div>
            </div>

            <div className="input-group">
              <p className="message-segment-label messageSet">Build Message Set</p>
              <div className="message-segment-textarea-wrapper groupModal"></div>
            </div>
            <InsertMessageSet
              handleAddBlock={(data) => {
                setMessageGroupData({
                  title: messageGroupData?.title,
                  blocks: [...messageGroupData?.blocks, data],
                });
              }}
            />
            <div className="blocks-wrapper messageSettingsWraper">
              {messageGroupData?.blocks?.length > 0
                ? messageGroupData?.blocks?.map((item, i) => (
                    <div key={i} className="message-block-item">
                      {item?.map((newData, index) => (
                        <span key={index}>{newData.contents} </span>
                      ))}
                      <button onClick={() => handleRemoveMessageBlock(i)}>
                        X
                      </button>
                    </div>
                  ))
                : <p className="noBlockText">No Message Blocks Created Yet.</p>}
            </div>
            <div className="buttonWraper customizeWraper messageSettingsBtnModalWraper">
              <button
                className="cancelBtn creates"
                onClick={() => {
                  setOpenForm(() => false);
                }}
              >
                Cancel
              </button>
              <button className="confirmBtn" onClick={handleSubmit}>
                Save Message Group
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageGroupForm;
